export type ElkaApp = 'elka-manager' | 'quotes' | 'crm' | 'tasks';

const PRODUCTION_URLS: Record<ElkaApp, string> = {
  'elka-manager': 'https://app.elka-hashmal.co.il',
  quotes: 'https://quotes.elka-hashmal.co.il',
  crm: 'https://crm.elka-hashmal.co.il',
  tasks: 'https://tasks.elka-hashmal.co.il',
};

const STAGING_URLS: Record<ElkaApp, string> = {
  'elka-manager': 'https://elka-manager-stg.web.app',
  quotes: 'https://elka-quote-stg.web.app',
  crm: 'https://elka-crm-stg.web.app',
  tasks: 'https://elka-tasks-stg.web.app',
};

const DEV_URLS: Record<ElkaApp, string> = {
  'elka-manager': 'http://localhost:3000',
  quotes: 'http://localhost:3002',
  crm: 'http://localhost:3001',
  tasks: 'http://localhost:3005',
};

/** Base URL for an Elka app, given Vite's import.meta.env.MODE. */
export function getAppBaseUrl(app: ElkaApp, mode: string): string {
  if (mode === 'staging') return STAGING_URLS[app];
  if (mode === 'production') return PRODUCTION_URLS[app];
  return DEV_URLS[app];
}
